// const { group } = require("d3-array");
var { isMobile } = require("./lib/breakpoints.js");

var { COLORS, makeTranslate, classify, formatStyle, fmtComma, wrapText } = require("./lib/helpers");

var d3 = {
  ...require("d3/dist/d3.min.js"),
  ...require("d3-array/dist/d3-array.min.js"),
  // ...require("d3-force/dist/d3-force.min.js"),
  // ...require("d3-quadtree/dist/d3-quadtree.min.js"),
  // ...require("d3-transition/dist/d3-transition.min.js"),

  
};

let dotRadius = 2;
let dotsPerGroup = 10000;
let dotRadiusSmall = 1;
let dotsPerGroupSmall = 5000;
var HIDE_TEXT = 6;
var MIN_TEXT = 10;

var formatData = function(input) {
  
  let data = {
    children:[]
  };

  input.forEach((d,i) => {

    data.children.push({
      group:i,
      value:d.pop,
      category:d.category,
      budget:d.budget,
      labels: d.labels
    })
  })
  //console.log(data);
  return data;
}

// Render circles.
var renderClusters = function(config) {
  // Setup
  var { labelColumn, valueColumn } = config;

  var margins = {
    top: 0,
    right: 10,
    bottom: 20,
    left: 10
  };

  var ticksX = 4;
  var roundTicksFactor = 5;

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight = 600;

  // make this the largest single total amount...TK// 
  let max = 1220;
  let radiusMax = isMobile.matches ? 100 : chartWidth<730 ? chartWidth*.2 : 160;
  //console.log(chartWidth);
  var radiusScale = d3
    .scaleLinear()
    .domain([0, max])
    .range([10, radiusMax]);



  var packHeight = 100

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", "translate(" + margins.left + "," + margins.top + ")");

  let drawCircles = function(configB) {

    var { color, data, posX = chartWidth/2, posY = chartHeight / 2, rowHeight = 100 } = configB;

    let pack = (data) => d3.pack()
      .size([chartWidth/2,rowHeight])
      .padding(1)
      .radius(d => radiusScale(d.value)) 
    (d3.hierarchy(data)
      .sum(d => d.value))

    var data = formatData(data);
    // console.log(data)

    const nodes = pack(data).leaves();
    const simulation = d3.forceSimulation(nodes)
        .force("x", d3.forceX(chartWidth/2 / 2).strength(0.01))
        .force("y", d3.forceY(rowHeight / 2).strength(0.01))
        .force("cluster", forceCluster())
        .force("collide", forceCollide());

    var clusterElement = chartElement.append("g")
      .attr("class", classify(configB.data[0].budget));

    const node = clusterElement.append("g")
      .selectAll("circle")
      .data(nodes)
      .join("circle")
        .attr("cx", d => d.x + posX)
        .attr("cy", d => d.y + posY)
        .attr("fill", function(d) {
          if (d.data.budget == 'Mandatory') {
            return COLORS.teal5;
          }
          else if (d.data.budget == 'Discretionary') {
            return COLORS.orange5;
          }
          else {
            return COLORS.red5;
          }
        })
        .attr("category", d => d.data.category)
        .attr("class", "circle")
    //Bubble labels
    clusterElement
      .append("g")
      .selectAll("text")
      .data(nodes)
      .enter()
      .append('text')
      .attr("x", d => d.x + posX)
      .attr("y", function(d) {
        /*var bubble = chartElement.selectAll("circle").filter(function(t) { 
          return t.getAttribute("category") == d.data.labels })
        return bubble.getAttribute("cy");*/
        return d.y + posY;
      })
        
      .attr("dy", function(d) {
        //fix label placements
        if (d.data.labels == 'Social Security') {
          if (isMobile.matches) {
            return -5;
          }
          return -45; }
        if (d.data.labels == 'Net interest') {
          if (isMobile.matches) {
            return  5;
          }
          return -5; }
        if (d.data.labels == 'Income security') {
          return -3; }
        if (d.data.labels == 'Medicare') {
          if (isMobile.matches) {
            return  5;
          }
          return -15; }
        if (d.data.labels == 'Medicaid') {
          if (isMobile.matches) {
            return  5;
          }
          return -10; }
        if (d.data.labels == 'Dept. of Defense') {
          if (isMobile.matches) {
            return  0;
          }
          return -15; 
        }
      })
      .attr("font-size", d => Math.max(radiusScale(d.value)/9*2.4, MIN_TEXT) + "px")
      .attr("display", d => radiusScale(d.value)/2 < HIDE_TEXT ? "none" : "block")
      .attr("class", "label-text")
      .attr("category",d => d.data.labels)
      .attr("cy", d => d.y)
      .text(function(d) {
        //only display labels for large bubbles
            if (radiusScale(d.value) >= 25) { 
              return d.data.labels; }
            else { return; }
      })
      // .call(wrapText, 50, 35);
    
      node.transition()
        .delay((d, i) => Math.random() * 500)
        .duration(750)
        .attrTween("r", d => {
          const i = d3.interpolate(0, d.r);
          return t => d.r = i(t);
        })
    
    /*simulation.on("tick", () => {
      node
          .attr("cx", d => d.x+ posX)
          .attr("cy", d => d.y+ posY)
    })*/

  }
  
  // Draw circle for each row in data
  let numRows = config.data.length;
  let posY = 230;
  let rowHeight = 100;

  let mandatory = config.data.filter(d => d.budget == "Mandatory")
  let discretionary = config.data.filter(d => d.budget == "Discretionary")  
  let interest = config.data.filter(d => d.budget == "Interest")  
    let config1 = {
      data: mandatory,
      posX: isMobile.matches ? chartWidth*.25 : chartWidth*.08,
      posY: isMobile.matches ? posY+75 : posY,
      groupSize: dotsPerGroup,
      rowHeight,
      color:  COLORS.blue3      
    };
    let config2 = {
      data: discretionary,
      posX: isMobile.matches ? chartWidth*.5 : chartWidth*.55,
      posY: isMobile.matches ? 50 : 65,
      groupSize: dotsPerGroup,
      rowHeight,
      color:  COLORS.blue3      
    };
    let config3 = {
      data: interest,
      posX: isMobile.matches ? chartWidth*.6 : chartWidth*.45,
      posY: isMobile.matches ? posY+275 : posY+190,
      groupSize: dotsPerGroup,
      rowHeight,
      color:  COLORS.blue3      
    };
  

  drawCircles(config1);
  drawCircles(config2);
  drawCircles(config3);

  /*
  // tweak text wrapping and positioning after ALL text blocks
  // have been written to the page.
  // this is not the cleanest way to do it but it works. ¯\_(ツ)_/¯
  */
  var labeledText = chartElement.selectAll("text").filter(function(t) {
    // filter out empty labels
    return t.data.labels != undefined;
  });
  labeledText["_groups"][0].forEach(function(txt){
    // using the text block's font size also its lineheight,
    // since this will vary depending on screen width
    var thisFontSize = parseInt(txt.getAttribute("font-size"));

    /*
    // at this point we'd want to figure out the width of the bubble
    // so we can pass that value onto the wrapText call.
    // but at this point that value doesn't seem to be available.
    // is it possible to store that as a data attribute on the circle when it's rendered?

    var thisCategory = txt.getAttribute("category");
    var thisBubble = document.querySelector(`circle[category="${ thisCategory }"]`);
    var thisBubbleWidth = parseInt(thisBubble.getAttribute("r")) * 2;
    d3.select(txt).call(wrapText, thisBubbleWidth, thisFontSize);
    */
    d3.select(txt).call(wrapText, 100, thisFontSize)
  });

  

  // labeledText.forEach(function(txt) {
  //   console.log(txt);
  // });
  // console.log(config.data);
  // chartElement 
  //   .select('text[category="Social Security"]')
  //   .attr("here", "heree")
  //   .attr("dy", 40)
  //   .call(wrapText, 250, 35);

  
  // Tooltips
  var chart = document.querySelector("#graphic");
  var tooltip = document.querySelector(".bubble-tooltip");

  function onMove(e) {
    var bounds = chart.getBoundingClientRect();
    var offsetX = e.clientX - bounds.left;
    var offsetY = e.clientY - 105;
    var category = e.target.getAttribute("category");
    var data = config.data.filter(d => d.category == category) 

    if (!category || !data) {
      return tooltip.classList.remove("show");
    }
    //Handle circle with > $1T 
    var unit = ' B';
    var trillion;
    if (data[0].category == 'Social Security') {
      unit = ' T';
      trillion = data[0].pop*.001;
    }
    //Handle text color for 3 diff budgets
    var textColor;
    if (data[0].budget == 'Mandatory') {
      textColor = COLORS.teal3;
    }
    else if (data[0].budget == 'Discretionary') {
      textColor = COLORS.orange3;
    }
    else {
      textColor = COLORS.red3;
    }

    //Handle tooltip wrapText
    var tooltipWidth;
    if (isMobile.matches) {
      tooltipWidth = "170px";
    }
    else {
      tooltipWidth = "200px";
    }

    tooltip.innerHTML = `
        <div class="tooltip-label"><h3 style="color: ${textColor}; max-width: ${tooltipWidth};">${data[0].category}</h3></div>
        <div class="tooltip-label number"><strong>$${
          (data[0].category == 'Social Security') ? trillion : data[0].pop
        }${unit}</strong></div>`

//Unused element: <div class="tooltip-label"><h4 style="color: ${textColor}; max-width: ${tooltipWidth};">${data[0].details != undefined ? data[0].details : ''}</h4></div>

tooltip.classList.add("show");
var left = offsetX < bounds.width / 2 ? offsetX + 10 : offsetX - 4 - tooltip.offsetWidth;
    tooltip.style.left = left + "px";
    tooltip.style.top = offsetY + 10 + "px";

/*var here = document.getElementsByClassName("bubble-tooltip")[0].getElementsByClassName("tooltip-label")[0].getElementsByTagName("h3")[0]
d3.select(here).attr('x', left).attr('y', offsetY + 10).call(wrapText, 50, 50)*/

}

chart.addEventListener("mousemove", onMove);

}

let m = 10;

const centroid = function centroid(nodes) {
  let x = 0;
  let y = 0;
  let z = 0;
  for (const d of nodes) {
    let k = d.r ** 2;
    x += d.x * k;
    y += d.y * k;
    z += k;
  }
  return {x: x / z, y: y / z};
}

const forceCollide = function forceCollide() {
  const alpha = 0.4; // fixed for greater rigidity!
  const padding1 = 0; // separation between same-color nodes
  const padding2 = 0; // separation between different-color nodes
  let nodes;
  let maxRadius;

  function force() {
    const quadtree = d3.quadtree(nodes, d => d.x, d => d.y);
    for (const d of nodes) {
      const r = d.r + maxRadius;
      const nx1 = d.x - r, ny1 = d.y - r;
      const nx2 = d.x + r, ny2 = d.y + r;
      quadtree.visit((q, x1, y1, x2, y2) => {
        if (!q.length) do {
          if (q.data !== d) {
            const r = d.r + q.data.r + (d.data.group === q.data.data.group ? padding1 : padding2);
            let x = d.x - q.data.x, y = d.y - q.data.y, l = Math.hypot(x, y);
            if (l < r) {
              l = (l - r) / l * alpha;
              d.x -= x *= l, d.y -= y *= l;
              q.data.x += x, q.data.y += y;
            }
          }
        } while (q = q.next);
        return x1 > nx2 || x2 < nx1 || y1 > ny2 || y2 < ny1;
      });
    }
  }

  force.initialize = _ => maxRadius = d3.max(nodes = _, d => d.r) + Math.max(padding1, padding2);

  return force;
}

const forceCluster = function forceCluster() {
  const strength = 0.2;
  let nodes;

  function force(alpha) {
    const centroids = d3.rollup(nodes, centroid, d => d.data.group);
    const l = alpha * strength;
    for (const d of nodes) {
      const {x: cx, y: cy} = centroids.get(d.data.group);
      d.vx -= (d.x - cx) * l;
      d.vy -= (d.y - cy) * l;
    }
  }

  force.initialize = _ => nodes = _;

  return force;
}




module.exports = renderClusters;
/*
renderChart(initialMode,"big");
renderChart(initialMode,"small");

var controls = document.querySelector('.controls');
window.addEventListener("resize", () => {
  renderChart($.one("input:checked", controls).value,"big")
  renderChart($.one("input:checked", controls).value,"small")
});*/